<div *ngIf="order" class="d-flex">
  <button
    [disabled]="!order?.log?.length"
    class="btn icon dark"
    (click)="vieOrderLog()"
  >
    <mat-icon matTooltip="View Logs">event_note</mat-icon>
  </button>
</div>
<ng-template #logDetail>
  <h2 class="order-log-title">Log</h2>
  <div *ngIf="order?.log?.length" class="invoice-log-sheet">
    <ng-container *ngFor="let log of sortedLogs">
      <div class="order-log-row" *ngIf="log.item !== 'NOTE'">
        <span class="log-row">
          {{ log.date | date: 'M/d/yy' }}
          <ng-container *ngIf="hasLogTime(log.date)">&nbsp;|&nbsp;{{ log.date | date: 'h:mm a' }}</ng-container>
          <ng-container *ngIf="log.initials">&nbsp;|&nbsp;{{ log.initials }}</ng-container>
          <ng-container *ngIf="log.item">
            &nbsp;|&nbsp;
            <ng-container *ngIf="logItemParts(log.item) as parts">
              <ng-container *ngIf="parts.value; else plainLogItem">
                {{ parts.label }} {{ logChangeArrow }} <strong class="log-item-value">{{ parts.value }}</strong>
              </ng-container>
              <ng-template #plainLogItem>{{ parts.label }}</ng-template>
            </ng-container>
          </ng-container>
        </span>
      </div>
    </ng-container>
  </div>
</ng-template>
